import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-182" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-183" data-mp="o3x58w0bc74w">
        <SectionHeading id="summary-title" data-id="element-184" data-mp="j883cm0tme5f">Everything <span className="text-aqua" data-id="element-185" data-mp="j5c5sysvxrhi">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-gray-200 bg-white sm:grid-cols-2" data-id="element-186" data-mp="1guf93z8v2cjd">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-gray-200 p-4 sm:odd:border-r" data-id="element-187" data-mp="16wrdl73fl105">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-aqua" data-id="element-188" data-mp="12vfu7jb5hc0e">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-189" data-mp="3rni5fu4pnjd7" />
              </span>
              <b className="text-sm font-medium text-navy" data-id="element-190" data-mp="3nl591wbusxt3">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}